import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { AuthService } from '../../../auth/services/auth.service';
import { renewToken } from '../../../auth/store/auth/auth.actions';
import type { User } from '../../../user/models/user';
import { checkProjectsExistence, setCurrentUser, setUserCounts } from '../../../user/store/user-info/user-info.actions';
import { loadLocalizationSettings } from '../../../user/store/user-settings/user-settings.actions';
import { UtilsService } from '../helpers/utils.service';

@Injectable({
  providedIn: 'root',
})
export class AppInitService {
  private store = inject<Store>(Store);
  private utils = inject(UtilsService);
  private authService = inject(AuthService);

  init() {
    return new Promise(resolve => {
      const token = this.utils.storage.token || '';
      if (this.authService.isLoggedIn()) {
        let user: User;
        try {
          user = this.utils.storage.get('user');
        } catch {
          // A stored user that no longer validates is as unusable as none: drop the
          // session so `authGuard` sends the browser to a fresh login instead of booting half-set-up.
          this.utils.storage.clearToken();
          this.utils.storage.clearUser();
          resolve(true);
          return;
        }
        this.store.dispatch(setCurrentUser({ user }));
        this.store.dispatch(renewToken({ token }));
        this.store.dispatch(loadLocalizationSettings());
        this.store.dispatch(checkProjectsExistence());
        this.store.dispatch(setUserCounts());
      }
      resolve(true);
    });
  }
}
